module.exports = __webpack_public_path__ + "static/media/Image_Landing_Devices.1f5e72a3.png";